/**
* Validate field
* @param {string|number|null} value - to validate
* @param {Array} validations - to apply on the value
* @param {string} otherValues - other fields used for decision if valid or not
* @return {string|null} text of the error
*/
export default function validateField(value, validations, otherValues) {
  var errors = (validations || []).reduce(function (errors, validation) {
    return errors.concat(validation(value, otherValues) || []);
  }, []);
  return errors[0] || null;
}